/**
 * Utilitários para detecção de plataforma e navegador
 */

export const getPlatformInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  return {
    isAndroid: /android/.test(userAgent),
    isIOS: /iphone|ipad|ipod/.test(userAgent),
    isChrome: /chrome/.test(userAgent) && !/edg/.test(userAgent),
    isEdge: /edg/.test(userAgent),
    isSafari: /safari/.test(userAgent) && !/chrome/.test(userAgent) && !/edg/.test(userAgent),
    isFirefox: /firefox/.test(userAgent),
    isMobile: /android|iphone|ipad|ipod/.test(userAgent),
    isDesktop: !/android|iphone|ipad|ipot/.test(userAgent),
  };
};

export const getBrowserName = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/edg/.test(userAgent)) return 'Edge';
  if (/chrome/.test(userAgent)) return 'Chrome';
  if (/safari/.test(userAgent)) return 'Safari';
  if (/firefox/.test(userAgent)) return 'Firefox';
  if (/android/.test(userAgent)) return 'Android Browser';

  return 'Unknown Browser';
};

export const isAppInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches;
};

export const isPWACapable = () => {
  const platform = getPlatformInfo();
  return (
    platform.isChrome ||
    platform.isEdge ||
    platform.isAndroid ||
    platform.isIOS ||
    platform.isSafari
  );
};

export const getInstallationInstructions = () => {
  const platform = getPlatformInfo();

  if (platform.isAndroid || platform.isChrome || platform.isEdge) {
    return {
      title: 'Instale o App APEM',
      description: 'Instale o app APEM no seu dispositivo para acessar offline e ter uma experiência melhor.',
      type: 'native', // Usa o prompt nativo do navegador
    };
  }

  if (platform.isIOS) {
    return {
      title: 'Instale o App',
      description: 'Toque em Compartilhar e depois em Adicionar à Tela de Início para instalar o app APEM.',
      type: 'manual',
      steps: [
        'Toque em Compartilhar',
        'Selecione "Adicionar à Tela de Início"',
        'Confirme o nome do app',
      ],
    };
  }

  if (platform.isSafari && platform.isDesktop) {
    return {
      title: 'Instale o App',
      description: 'Clique no ícone de compartilhamento e selecione "Adicionar à Tela de Início" para instalar o app APEM.',
      type: 'manual',
      steps: [
        'Clique em Compartilhar (ícone de seta)',
        'Selecione "Adicionar à Tela de Início"',
        'Confirme o nome do app',
      ],
    };
  }

  return null;
};

export const logPlatformInfo = () => {
  const platform = getPlatformInfo();
  const browser = getBrowserName();
  const installed = isAppInstalled();

  console.group('📱 Platform Information');
  console.log('Browser:', browser);
  console.log('Platform:', platform);
  console.log('App Installed:', installed);
  console.groupEnd();
};
